// extracted by mini-css-extract-plugin
module.exports = {"uploadDisclaimer":"sjrzT70z","styledAnchor":"w9CcboQx"};